import React from 'react';
import { Box, Avatar, Typography, Tooltip, Checkbox, useTheme, ButtonBase } from '@mui/material';
import { PurchaseOrderItem } from '@domain/purchasing';
import { APP_CONFIG } from '@config/app.config';

interface ProductDisplayProps {
  purchaseOrderItems: PurchaseOrderItem[];
  selectedItems?: PurchaseOrderItem[];
  onSelectionChange?: (selectedItems: PurchaseOrderItem) => void;
}

export const ProductDisplay: React.FC<ProductDisplayProps> = ({ purchaseOrderItems, selectedItems, onSelectionChange }) => {


  const theme = useTheme();
  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap={2} overflow="auto">
      {purchaseOrderItems.map((item) => (
        <Box
          display="flex"
          alignItems="center"
          component={ButtonBase}
          gap={2}
          key={item.product.id}
          onClick={() => onSelectionChange?.(item)}
          sx={{
            borderRadius: 2,
            p: 2,
            border: '1px solid',
            borderColor: selectedItems?.some(selectedItem => selectedItem.id === item.id) ? theme.palette.primary.main : theme.palette.divider,
            width: 250,
          }}
        >
          {selectedItems && (
            <Checkbox
              checked={selectedItems?.some(selectedItem => selectedItem.id === item.id)}
              onChange={() => onSelectionChange?.(item)}
            />
          )}
          <Avatar
            variant="rounded"
            sx={{
              border: 1,
              borderColor: APP_CONFIG.ui.theme.colors.border,
              width: 30,
              height: 30,
            }}
            src={item.product.image}
            alt={item.product.title}
          />
          <Typography
            variant="caption"
            sx={{
              textAlign: 'left',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            }}
          >
            {item.product.title}
          </Typography>

          {item.quantity && (
            <Box>
              <Typography variant="caption" color="text.secondary" noWrap>
                {item.quantity} items
              </Typography>
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}; 